export class PreRequisites {
  PreRequisiteDetailsId: number;
  PrerequisiteName: string;
  TypeOfData: string;
  IsExpireyDateNeeded: boolean;
  IsDelete: boolean = false;
}
export class PassType {
  PassTypeId: number = 0;
  PassTypeName: string;
  Checked: boolean = false;
  IsDelete: boolean = false;
}
export class PreReqConfiguration {
  UnitId: number;
  CompanyId: number;
  LocationId: number;
  PassTypeId: number;
  PreRequisiteIds: any[] = [];
}

export class PrerequisiteDetails {
  PrerequisiteId: number;
  PrerequisiteName: string;
  PreRequisiteDetailsId: number;
  Checked: boolean;
}
